import styled from 'styled-components';

/**
 * The note above the association page. Deliberately plain and quiet rather than an alert: it is
 * telling the reader what this page is, not warning them about anything.
 */
export const HonoraryNote = styled.div`
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.gray['100']};
  border-left: 4px solid ${({ theme }) => theme.colors.tertiaries.darker};

  strong {
    display: block;
    color: ${({ theme }) => theme.colors.tertiaries.darker};
  }

  p {
    margin-top: 4px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray['500']};
  }
`;
